import { DataType } from "../../pages/private/Global/Import/Import";
import { EnvType } from "../user/userTypes";

export interface HistoricList {
  _id?: string;
  created_at: string;
  filename: string;
  username: string;
  status: string;
  message: string;
  userId: string;
  envType: EnvType;
  distributorName: string;
  dataType: DataType
  period: string[]
}

export interface LastImport {
  username: string;
  distributorName: string;
  created_at: string;
}

export interface importsState {
  FsHistoric: Historic;
  RetailHistoric: Historic;
  importStatus: ImportsStatus[]
  isDialogOpen: boolean
  config: ImportConfig
  fileData: FileData
}

export interface ImportConfig {
  steps: ImportSteps[]
}

export enum ImportSteps {
  Default = 'default',
}

export interface FileData {
  startDate: string,
  endDate: string,
  distributor: string,
  fileName: string
}

export interface ImportsStatus {
  distrib: string
  statusPerMonth: {
    [key: string]: string
  }
}

export interface Historic {
  list: HistoricList[];
  lastImport: LastImport[] | [];
}



export enum ContactSteps {
  Default = 'default',
  MobileContact = 'fmobile-contact',
  Appointment = 'appointment',
  EmailContact = 'remail-contact',
  MobileValidation = 'mobile-validation',
}

export interface ContactState {
  open: boolean
  config: ContactConfig
}

export interface ContactConfig {
  steps: ContactSteps[]
}
